import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG, IAppConfig } from './../../app.config';
import { ListPreferences } from './user-preferences.service';

@Injectable()
export class ListPreferencesClient {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/preferences/list`;
  }

  private readonly _endpoint: string;

  create(pref: ListPreferences): Observable<any> {
    return this._client.post(`${this._endpoint}/${pref.id}`, JSON.stringify(pref));
  }

  get(id: number): Observable<any> {
    return this._client.get(`${this._endpoint}/${id}`);
  }

  update(pref: ListPreferences): Observable<any> {
    return this._client.put(`${this._endpoint}/${pref.id}`, JSON.stringify(pref));
  }

  updatePageSize(id: number, pageSize: number): Observable<void> {
    return this._client.put<void>(`${this._endpoint}/${id}/page-size`, { pageSize });
  }
}
